// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/ProjectSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/ProjectSearchBy.proto.
 */
export const file_Enumerations_ProjectSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CiJFbnVtZXJhdGlvbnMvUHJvamVjdFNlYXJjaEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyq7AQoPUHJvamVjdFNlYXJjaEJ5EicKG1BST0pFQ1RfU0VBUkNIX0JZX1RFTkFOVF9JRBAAGgbKx80PAQMSIgoWUFJPSkVDVF9TRUFSQ0hfQllfTkFNRRABGgbKx80PAQQSKQodUFJPSkVDVF9TRUFSQ0hfQllfREVTQ1JJUFRJT04QAhoGysfNDwEFEjAKJFBST0pFQ1RfU0VBUkNIX0JZX0VYVEVSTkFMX1JFRkVSRU5DRRADGgbKx80PAQpCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a project can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.ProjectSearchBy
 */
export enum ProjectSearchBy {
  /**
   * Search through the tenant id of a project.
   *
   * @generated from enum value: PROJECT_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the name of a project.
   *
   * @generated from enum value: PROJECT_SEARCH_BY_NAME = 1;
   */
  NAME = 1,

  /**
   * Search through the description of a project.
   *
   * @generated from enum value: PROJECT_SEARCH_BY_DESCRIPTION = 2;
   */
  DESCRIPTION = 2,

  /**
   * Search through the external reference text of a project.
   *
   * @generated from enum value: PROJECT_SEARCH_BY_EXTERNAL_REFERENCE = 3;
   */
  EXTERNAL_REFERENCE = 3,
}

/**
 * Describes the enum time_tracking.enumerations.ProjectSearchBy.
 */
export const ProjectSearchBySchema: GenEnum<ProjectSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_ProjectSearchBy, 0);

